import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';

import { DataroomBrowserBreadcrumbsComponent } from './dataroom-browser-breadcrumbs.component';

export const imports: NgModule['imports'] = [MatButtonModule, MatIconModule, FlexLayoutModule];

@NgModule({
  declarations: [DataroomBrowserBreadcrumbsComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [DataroomBrowserBreadcrumbsComponent],
})
export class DataroomBrowserBreadcrumbsModule {}
